"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannerVideo = exports.BannerTitleLinkImitation = exports.BannerTitle = exports.BannerTextContainer = exports.BannerImage = exports.Banner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _models = require("../../models");
var _constants = require("../BannerProductListing/constants");
const Banner = exports.Banner = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, hasLink, size } = param;
    return {
        maxHeight: 385,
        position: 'relative',
        borderRadius: theme.spacing(1),
        overflow: 'hidden',
        '&:hover': {
            '& img': {
                filter: hasLink ? 'brightness(0.8)' : 'none',
                cursor: hasLink ? 'pointer' : 'default'
            },
            '& div': {
                color: hasLink ? theme.palette.common.white : 'auto',
                textDecorationColor: hasLink ? theme.palette.common.white : 'auto'
            }
        },
        order: size === _models.EditorialPlpPromoBannerSize.Size2 ? 5 : 'inherit',
        gridColumn: size === _models.EditorialPlpPromoBannerSize.Size2 ? 'span 2' : 'inherit',
        maxWidth: '100%',
        [theme.breakpoints.up('sm')]: {
            order: 'inherit',
            maxWidth: _constants.BANNER_SIZE_IN_PX[size]
        }
    };
});
const BannerImage = exports.BannerImage = (0, _mui.styled)('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover'
});
const BannerVideo = exports.BannerVideo = (0, _mui.styled)('video')({
    width: '100%',
    height: '100%',
    objectFit: 'cover'
});
const BannerTitleLinkImitation = exports.BannerTitleLinkImitation = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'fontColor'
    ])
})((param)=>{
    let { theme, fontColor } = param;
    return {
        textDecoration: 'underline',
        textTransform: 'uppercase',
        marginTop: theme.spacing(1),
        textUnderlineOffset: theme.spacing(1),
        textDecorationThickness: 2,
        color: fontColor
    };
});
const BannerTextContainer = exports.BannerTextContainer = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, verticalAlignment, fontColor } = param;
    return {
        position: 'absolute',
        top: verticalAlignment === _models.VerticalContentAlignment.Middle ? '50%' : verticalAlignment === _models.VerticalContentAlignment.Top ? '20%' : '80%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: fontColor,
        textAlign: 'center',
        width: '100%',
        margin: theme.spacing(0, 0, 2),
        padding: theme.spacing(0, 3)
    };
});
const BannerTitle = exports.BannerTitle = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        fontSize: '2rem'
    };
});
